import DOMPurify from 'dompurify'

import { useDefaultWorkspaceStore } from '../services/workspace'

export const sanitizeContent = (content?: string | null) => {
  if (!content) return ''

  return DOMPurify.sanitize(content)
}

export const SortOrderMap: (sortOrder: string) => any = (sortOrder: string) => {
  switch (sortOrder) {
    case 'asc':
      return 'ascend'
    case 'desc':
      return 'descend'
    case 'ascend':
      return 'asc'
    case 'descend':
      return 'desc'
    default:
      return undefined
  }
}

export const getColorFromChar = (char: string) => {
  const colors = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#9e9e9e',
    '#607d8b',
    '#a1887f',
    '#90a4ae',
    '#f06292',
    '#ba68c8',
    '#9575cd',
    '#7986cb',
    '#4db6ac',
  ]
  const code = char.toUpperCase().charCodeAt(0) - 65
  return colors[code % colors.length] || '#ccc'
}

export const formatNumberToPrefix = (number: number) => {
  if (!number) return '0'

  if (number < 10_000) {
    // Show full number with commas for readability (e.g., "9,999")
    return number.toLocaleString('en-US')
  }

  return number.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    notation: 'compact',
    compactDisplay: 'short',
  })
}

export const normalizeString = (str: string = ''): string => {
  return str
    .normalize('NFD') // Normalize to decomposed form (e.g., é → e + ́)
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .toLowerCase()
    .trim()
}



export const generatePath = (subPath?: string, workspaceId?: string): string => {
  const defaultWorkspaceId = useDefaultWorkspaceStore.getState().defaultWorkspace?.id

  if (subPath && workspaceId) return `/workspaces/${workspaceId}${subPath}`

  if (!defaultWorkspaceId && workspaceId) return `/workspaces/${workspaceId}`

  if (!subPath) return `/workspaces/${defaultWorkspaceId}`

  return `/workspaces/${defaultWorkspaceId}${subPath}`
}
